import React, { useState } from 'react';

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Divider,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Theme,
  Typography,
  makeStyles,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import { ReactComponent as OkIcon } from '../../../../assets/img/icon/Ok.svg';
import { ReactComponent as AutoSvg } from '../../../../assets/img/sinister/robbery/car_top_view.svg';
import { ReactComponent as SelectedTire } from '../../../../assets/img/sinister/robbery/tire_selected.svg';
import { ReactComponent as UnselectedTire } from '../../../../assets/img/sinister/robbery/tire_unselected.svg';
import FloatingButton from '../../../../components/FloatingButton';
import { useSinisterDataContext } from '../../../../context/sinister/sinister.provider';

const tiresName: any = {
  front_left: 'Delantera lado conductor',
  front_right: 'Delantera lado acompañante',
  back_left: ' Trasera lado conductor',
  back_right: 'Trasera lado acompañante',
  back: 'Rueda de auxilio',
};

const useStyle = makeStyles((theme: Theme) => ({
  selectedCard: {
    background: theme.palette.background.default,
  },
  // heading: {
  //   fontSize: theme.typography.pxToRem(15),
  //   fontWeight: theme.typography.fontWeightRegular,
  // },
}));

const StolenTires = () => {
  const { nextStep, updateSinisterBody, sinister_body } =
    useSinisterDataContext();
  const classes = useStyle();

  const theme = useTheme();
  const matches = useMediaQuery(
    theme.breakpoints.down('sm') || theme.breakpoints.down('md')
  );

  const [state, setState] = useState({
    back_right: sinister_body?.robbery?.tires?.back_right || false,
    back_left: sinister_body?.robbery?.tires?.back_left || false,
    front_left: sinister_body?.robbery?.tires?.front_left || false,
    front_right: sinister_body?.robbery?.tires?.front_right || false,
    back: sinister_body?.robbery?.tires?.back || false,
  });

  const [tiresSelected] = useState<any>({
    tires: [],
  });

  const callNextStep = () => {
    const arrayOfTires = Object.values(state);
    const onlyTrue = arrayOfTires.filter((tire: boolean) => tire === true);
    updateSinisterBody({
      robbery: {
        ...sinister_body.robbery,
        tires: { ...state, tires_selected: onlyTrue.length },
      },
    });
    nextStep();
  };

  const isDisabled = () => {
    const check = Object.values(state).some((element) => element === true);
    return !check;
  };

  const handleCheckboxChange = (prop: string, value: boolean) => {
    const indexof = tiresSelected.tires.indexOf(prop);
    !tiresSelected.tires.includes(prop)
      ? tiresSelected.tires.push(prop)
      : tiresSelected.tires.splice(indexof, 1);
    setState({ ...state, [prop]: !value });
  };

  return (
    <>
      {matches ? (
        <>
          <Grid item xs={12}>
            <Box my={3}>
              <Typography variant="h6" color="textPrimary">
                Indicanos qué neumáticos te robaron
              </Typography>
            </Box>
          </Grid>
          <Box mb={5}>
            <Grid container xs={12} justify="center" alignItems="center">
              <Grid item xs={12}>
                <Box textAlign="center">
                  <AutoSvg></AutoSvg>
                </Box>
              </Grid>
              {/* rueda 1 */}
              <Box position={'absolute'} ml={-25} mt={-20}>
                <Box
                  onClick={() =>
                    handleCheckboxChange('front_left', state.front_left)
                  }
                >
                  {state.front_left ? <SelectedTire /> : <UnselectedTire />}
                </Box>
              </Box>
              {/* rueda 2 */}
              <Box position={'absolute'} ml={25} mt={-20}>
                <Box
                  onClick={() =>
                    handleCheckboxChange('front_right', state.front_right)
                  }
                >
                  {state.front_right ? <SelectedTire /> : <UnselectedTire />}
                </Box>
              </Box>
              {/* rueda 3 */}
              <Box position={'absolute'} ml={-25} mt={20}>
                <Box
                  onClick={() =>
                    handleCheckboxChange('back_left', state.back_left)
                  }
                >
                  {state.back_left ? <SelectedTire /> : <UnselectedTire />}
                </Box>
              </Box>
              {/* rueda 4 */}
              <Box position={'absolute'} ml={25} mt={20}>
                <Box
                  onClick={() =>
                    handleCheckboxChange('back_right', state.back_right)
                  }
                >
                  {state.back_right ? <SelectedTire /> : <UnselectedTire />}
                </Box>
              </Box>
              {/* rueda auxiliar */}
              <Box textAlign="center">
                <Box onClick={() => handleCheckboxChange('back', state.back)}>
                  {state.back ? <SelectedTire /> : <UnselectedTire />}
                </Box>
              </Box>
            </Grid>
          </Box>

          <Grid container justify="center">
            <Grid item xs={12} sm={6}>
              <Accordion
                style={{ boxShadow: 'none' }}
                disabled={tiresSelected.tires.length === 0}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography>
                    {/* <Typography className={classes.heading}> */}
                    {tiresSelected.tires.length} neumáticos seleccionados
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Grid container xs={12} justify="center" alignItems="center">
                    <Grid item xs={12}>
                      <Box>
                        <List>
                          {tiresSelected.tires
                            .filter(
                              (tire: any, index: any) =>
                                tiresSelected.tires.indexOf(tire) === index
                            )
                            .map((tire: string) => (
                              <ListItem>
                                <ListItemIcon>
                                  <OkIcon />
                                </ListItemIcon>
                                <ListItemText
                                  disableTypography
                                  primary={
                                    <Typography variant="body2">
                                      {tiresName[tire]}
                                    </Typography>
                                  }
                                />
                              </ListItem>
                            ))}
                        </List>
                      </Box>
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>
              <Box>
                <Divider variant="fullWidth" />
              </Box>
              <FloatingButton onClick={callNextStep} disabled={isDisabled()}>
                Continuar
              </FloatingButton>
            </Grid>
          </Grid>
        </>
      ) : (
        <>
          <Grid item xs={12}>
            <Box my={3}>
              <Typography variant="h6" color="textPrimary">
                Indicanos qué neumáticos te robaron
              </Typography>
            </Box>
          </Grid>
          <Grid container xs={12} justify="center" alignItems="center">
            <Grid item xs={12}>
              <Box mt={5} textAlign="center">
                <AutoSvg></AutoSvg>
              </Box>
            </Grid>

            {/* rueda 1 */}
            <Box position={'absolute'} ml={-45} mt={-25}>
              <Typography variant="subtitle1">
                Delantera lado conductor
              </Typography>
            </Box>
            <Box position={'absolute'} ml={-25} mt={-10}>
              <Box
                onClick={() =>
                  handleCheckboxChange('front_left', state.front_left)
                }
              >
                {state.front_left ? <SelectedTire /> : <UnselectedTire />}
              </Box>
            </Box>

            {/* rueda 2 */}
            <Box position={'absolute'} ml={50} mt={-25}>
              <Typography variant="subtitle1">
                Delantera lado acompañante
              </Typography>
            </Box>
            <Box position={'absolute'} ml={25} mt={-10}>
              <Box
                onClick={() =>
                  handleCheckboxChange('front_right', state.front_right)
                }
              >
                {state.front_right ? <SelectedTire /> : <UnselectedTire />}
              </Box>
            </Box>

            {/* rueda 3 */}
            <Box position={'absolute'} ml={-45} mt={10}>
              <Typography variant="subtitle1">
                Trasera lado conductor
              </Typography>
            </Box>
            <Box position={'absolute'} ml={-25} mt={25}>
              <Box
                onClick={() =>
                  handleCheckboxChange('back_left', state.back_left)
                }
              >
                {state.back_left ? <SelectedTire /> : <UnselectedTire />}
              </Box>
            </Box>

            {/* rueda 4 */}
            <Box position={'absolute'} ml={50} mt={10}>
              <Typography variant="subtitle1">
                Trasera lado acompañante
              </Typography>
            </Box>
            <Box position={'absolute'} ml={25} mt={25}>
              <Box
                onClick={() =>
                  handleCheckboxChange('back_right', state.back_right)
                }
              >
                {state.back_right ? <SelectedTire /> : <UnselectedTire />}
              </Box>
            </Box>

            {/* rueda auxiliar */}
            <Box textAlign="center" position={'absolute'} mt={65}>
              <Typography variant="subtitle1">Rueda de auxilio</Typography>
            </Box>
            <Box textAlign="center" position={'absolute'} mt={55}>
              <Box onClick={() => handleCheckboxChange('back', state.back)}>
                {state.back ? <SelectedTire /> : <UnselectedTire />}
              </Box>
            </Box>
          </Grid>
          <Grid container justify="center">
            <Grid item xs={12} sm={6}>
              <FloatingButton onClick={callNextStep} disabled={isDisabled()}>
                Continuar
              </FloatingButton>
            </Grid>
          </Grid>
        </>
      )}
    </>
  );
};

export default StolenTires;
